import React from "react";
import styles from "./SummonerRank.module.css";

export const SummonerRank = ({
  type,
  tier,
  division,
  lp,
  wins,
  losses,
  width,
}) => {
  if (!tier)
    return (
      <div className={styles.wrapper}>
        <div className={styles.rankicon}>
          <img
            src={`https://cdn5.xdx.gg/emblem45/unranked.webp`}
            srcSet={`https://cdn5.xdx.gg/emblem45/unranked.webp 45w,
                             https://cdn5.xdx.gg/emblem90/unranked.webp 90w,
                             https://cdn5.xdx.gg/emblem135/unranked.webp 135w`}
            width="45"
            height="45"
            alt="unranked"
          />
          {type}
        </div>
        <div className={styles.unranked}>unranked</div>
      </div>
    );

  const w = parseInt(wins);
  const l = parseInt(losses);
  const wr = ((w * 100) / (w + l)).toFixed(2);

  return (
    <>
      <div>
        <div className={styles.wrapper}>
          <div className={styles.rankicon}>
            <img
              src={`https://cdn5.xdx.gg/emblem45/${tier.toLowerCase()}.webp`}
              srcSet={`https://cdn5.xdx.gg/emblem45/${tier.toLowerCase()}.webp 45w,
                             https://cdn5.xdx.gg/emblem90/${tier.toLowerCase()}.webp 90w,
                             https://cdn5.xdx.gg/emblem135/${tier.toLowerCase()}.webp 135w`}
              width="45"
              height="45"
              alt={tier.toLowerCase()}
            />
            {type}
          </div>
          <div>
            <div>
              {tier.toLowerCase()}{" "}
              {tier !== "CHALLENGER" &&
                tier !== "GRANDMASTER" &&
                tier !== "MASTER" &&
                division}
            </div>
            <div className={styles["stats_" + width]}>
              <div>
                {lp || 0}
                <br />
                LP
              </div>
              <div>
                {wr} %<br />
                win rate
              </div>
              {width !== "small" && width !== "xsmall" && width !== "tiny" && (
                <div>
                  {wins || 0} W<br />
                  {losses || 0} L
                </div>
              )}
            </div>
          </div>
        </div>
        {(width === "small" || width === "xsmall" || width === "tiny") && (
          <>
            <div className={styles.winloss}>
              {wins || 0} Win • {losses || 0} Loss
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SummonerRank;
